import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import Lottie from "lottie-react";
import PropTypes from "prop-types";
import React from "react";
import { Modal } from "react-bootstrap";
import animationData from "./lottie/warning-light.json";

const WizardModal = ({ modal, setModal, title, description }) => {
  return (
    <Modal
      show={modal}
      onHide={() => setModal(false)}
      centered
      dialogClassName="wizard-modal"
    >
      <Modal.Body>
        <FalconCloseButton
          size="sm"
          className="position-absolute top-0 end-0 me-2 mt-2"
          onClick={() => setModal(!modal)}
        />
        <Flex justifyContent="center" alignItems="center">
          <Lottie
            animationData={animationData}
            loop={true}
            style={{ width: "100px" }}
          />
          <div className="mb-0 flex-1 d-flex flex-column">
            <h6 className="fs-8">{title}</h6>
            <h6 className="fs-10">{description}</h6>
          </div>
        </Flex>
      </Modal.Body>
    </Modal>
  );
};

WizardModal.propTypes = {
  modal: PropTypes.bool.isRequired,
  setModal: PropTypes.func.isRequired,
};

export default WizardModal;
